import { enableFade } from 'core/handlers/FadeHandler'
import { signal } from 'services/SignalsService'

export default class MenuEntityBg extends  PIXI.Container {
  constructor() {
    super()
    const fade = enableFade(this)

    signal.on('RADIO:ui', (value) => {
      fade(value == 'menu')
    })
  }
}
